'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn } from '@/utils/styles';

const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof SliderPrimitive.Root> & {
    trackClassName?: string;
    rangeClassName?: string;
    thumbClassName?: string;
    label?: (value: number) => React.ReactNode;
    labelPosition?: 'top' | 'bottom';
  }
>(
  (
    {
      className,
      trackClassName,
      rangeClassName,
      thumbClassName,
      label,
      labelPosition,
      ...props
    },
    ref,
  ) => (
    <SliderPrimitive.Root
      ref={ref}
      className={cn(
        'relative flex w-full touch-none select-none items-center',
        className,
      )}
      {...props}>
      <SliderPrimitive.Track
        className={cn(
          'relative h-1.5 w-full grow overflow-hidden rounded-full bg-electricBlue-900/20',
          trackClassName,
        )}>
        <SliderPrimitive.Range
          className={cn('absolute h-full bg-electricBlue-700', rangeClassName)}
        />
      </SliderPrimitive.Track>
      <SliderPrimitive.Thumb
        className={cn(
          'block size-5 rounded-full border-2 border-electricBlue-400 bg-electricBlue-600 shadow transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50',
          thumbClassName,
        )}>
        {label && (
          <span
            className={cn(
              'absolute flex w-full justify-center',
              labelPosition === 'top' && '-top-5',
              labelPosition === 'bottom' && 'top-4',
            )}>
            {props.value && label(props.value[0])}
          </span>
        )}
      </SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  ),
);
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
